interface ReceiptAgentManagerReviewVisibility {
  receiptAgentFlyoutEnabled: boolean
  managerReviewRulesEnabled: boolean
}

export const shouldRenderReceiptAgentManagerReview = ({
  receiptAgentFlyoutEnabled,
  managerReviewRulesEnabled,
}: ReceiptAgentManagerReviewVisibility): boolean =>
  receiptAgentFlyoutEnabled && managerReviewRulesEnabled
